import { useColorScheme } from "react-native";
import { palette } from "@heraion/shared";

// Web date field for the Plan composer's scheduled date: a native
// <input type="date"> (the browser's own date picker) instead of typing
// YYYY-MM-DD by hand. Injected into the shared PlanComposer through its
// `DateField` seam — the DOM input lives here because @heraion/ui has no
// DOM lib. value/onChange are "YYYY-MM-DD" | "". `colorScheme` themes the
// native picker chrome to match light/dark.
export function PlanDateField({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  const dark = useColorScheme() === "dark";
  const p = dark ? palette.dark : palette.light;
  return (
    <input
      type="date"
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
      aria-label="Scheduled date"
      style={{
        backgroundColor: p.bg,
        border: `1px solid ${p.border}`,
        borderRadius: 8,
        color: p.ink,
        fontSize: 16,
        padding: "8px 10px",
        minHeight: 44,
        boxSizing: "border-box",
        width: "100%",
        colorScheme: dark ? "dark" : "light",
        fontFamily: "inherit",
      }}
    />
  );
}
